module.exports = __webpack_public_path__ + "static/media/theia.16540da6.png";